module.exports = __webpack_public_path__ + "img/graph-icon-neon-blue-600.0631feda.png";